import React, { Component } from 'react';
import PropTypes from 'prop-types';

const iframeStyle = (hideName) => `
<style>
  html {
    color: white;
  }
  body {
    margin: 0;
  }
  .auth0-lock.auth0-lock .auth0-lock-center {
    display: block !important;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  ${(hideName ? `
  .auth0-lock.auth0-lock .auth0-lock-header {
    padding-top: 26px !important;
  }
  .auth0-lock.auth0-lock .auth0-lock-name {
    display: none;
  }
  ` : '')}
</style>`;

class Preview extends Component {
  static propTypes = {
    optionsString: PropTypes.string.isRequired,
    options: PropTypes.object.isRequired,
    hideName: PropTypes.bool
  }

  state = {
    screenMode: 'desktop',
    rendered: false
  }

  componentDidMount() {
    this.loadHtml();
  }

  componentDidUpdate() {
    this.loadHtml();
  }

  loadHtml = () => {
    // If the iframe element is not ready, don't try to write inside it
    if (!this.desktopIframe) return;
    if (this.state.rendered) {
      this.desktopIframe.contentWindow.postMessage(this.props.options, '*');
      return;
    }

    const html = `
<head>
  ${iframeStyle(this.props.hideName)}
</head>
<body>
  <script src="https://cdn.auth0.com/js/lock/10.16.0/lock.min.js"></script>

  <div id="lock-desktop"></div>

  <script>
    var options = {
      auth: {
        redirect: false
      },
      container: "lock-desktop",
      ${this.props.optionsString}
    }

    var w = new Auth0Lock(
      "7I3KXNi6ZeBq6oL0xnlfk1SrW6KntwR5",
      "pwdlessdemo.auth0.com",
      options
    );

    w.show();

    w.on('authenticated', function (authResult) {
      setTimeout(function () {
        w.hide();
        w.show();
      }, 3000);
    });

    window.addEventListener('message', function (event) {
      w.hide();
      w.show(event.data);
    }, false);
  </script>

  <script src="https://cdn.auth0.com/js/lock/10.16.0/es.js"></script>
  <script src="https://cdn.auth0.com/js/lock/10.16.0/it.js"></script>
  <script src="https://cdn.auth0.com/js/lock/10.16.0/zh.js"></script>
  <script src="https://cdn.auth0.com/js/lock/10.16.0/fr.js"></script>
  <script src="https://cdn.auth0.com/js/lock/10.16.0/de.js"></script>
  <script src="https://cdn.auth0.com/js/lock/10.16.0/ja.js"></script>

</body>`;

    this.desktopIframe.contentWindow.document.open();
    this.desktopIframe.contentWindow.document.write(html);
    this.desktopIframe.contentWindow.document.close();

    this.setState({ rendered: true });
  }

  render() {
    return (
      <div className="browser-web">
        <iframe
          className="iframe lock-iframe"
          ref={ref => { this.desktopIframe = ref; }}
        />
      </div>
    );
  }
}

export default Preview;



// WEBPACK FOOTER //
// ./src/components/Preview/Preview.js


// WEBPACK FOOTER //
// webpack:///src/components/Preview/Preview.js